// extracted by mini-css-extract-plugin
export default {"reverse":"Text_reverse__kMYvU"};